import $ from 'jquery'
import './popup.scss'

// Sometimes the video is not in a wide-enough container, so we want the video to become a bigger popup as soon as someone clicks play.
// This function basically does that.
// You just need to ensure one parent element has a data-videojs-popup-on-play attribute set.
// All video-js elements inside that element will open up in a popup
export const popupOnPlayIfDesired = (player, elem) => {
  const $elem = $(elem)

  if ($elem.closest('[data-videojs-popup-on-play]').length == 0) {
    return
  }

  // The video container
  const container = $(elem).closest('.video-js')

  // Let's wrapp the container in a div. We are going to portal the container to be at the end of the body in a separate popup to avoid zindex issues.
  // But we'll keep this wrapper in it's original position so we can put the video container back later.
  const wrapper = container
    .wrap("<div class='video-js-wrapper'></div>")
    .closest('.video-js-wrapper')

  // Create our popup - styled using scss.
  const popup = $("<div class='video-js-popup'></div>")
  const popupContent = $("<div class='video-js-popup__content'></div>")
  popup.append(popupContent)
  $('body').append(popup)

  let inPopup = false

  // Move the video-js container into the popup
  const moveToPopup = () => {
    if (inPopup) return
    inPopup = true
    wrapper.width(wrapper.width())
    wrapper.height(wrapper.height())
    popupContent.append(container)
    popup.addClass('has-video')
    if (player && player.paused()) {
      player.play()
    }
  }
  wrapper.on('click', moveToPopup)
  player.on('play', moveToPopup)

  // Move the video-js container back to the wrapper
  const moveToOriginalPosition = () => {
    if (!inPopup) return
    inPopup = false
    wrapper.append(container)
    wrapper.width('')
    wrapper.height('')
    popup.removeClass('has-video')
    if (player && !player.paused()) {
      player.pause()
    }
  }
  popup.on('click', (e) => {
    if (!popupContent[0].contains(e.target)) {
      moveToOriginalPosition()
    }
  })
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      moveToOriginalPosition()
    }
  })
}
